export interface HoverMenuSubItem {
  subItemDescription: string;
  subItemLinkTo: string;
}

export interface HoverMenuItem {
  mainSubMenuTitle: string;
  subItems: HoverMenuSubItem[];
}

export interface RouteItem {
  title: string;
  path: string;
  subMenu?: HoverMenuItem[];
}

const AUTHENTICATION: RouteItem = {
  title: "Login",
  path: "/login",
};

const PEOPLE_MANAGEMENT: RouteItem = {
  title: "Gestão de Pessoas",
  path: "/gestao-pessoas",
};

const PEOPLE_MANAGEMENT_PUNCH_CARD: RouteItem = {
  title: "Ponto Digital",
  path: "/gestao-pessoas/ponto-digital",
};

const PEOPLE_MANAGEMENT_GEOLOCATION_CARD: RouteItem = {
  title: "Geolocalização",
  path: "/gestao-pessoas/geolocalizacao",
};

const PERSONNEL_DEPARTMENT_PANEL: RouteItem = {
  title: "Painel DP",
  path: "/painel-dp",
};

const PERSONNEL_DEPARTMENT_OVERVIEW: RouteItem = {
  title: "Visão Geral",
  path: "/painel-dp/visao-geral",
};

const PERSONNEL_DEPARTMENT_SENDING_NOTICES: RouteItem = {
  title: "Envio de Avisos",
  path: "/painel-dp/envio-de-avisos",
};

const PERSONNEL_DEPARTMENT_PUNCH_CARD_OBSERVATIONS: RouteItem = {
  title: "Observações",
  path: "/painel-dp/observacoes",
};

const PERSONNEL_DEPARTMENT_MANAGEMENT_PANEL: RouteItem = {
  title: "Painel de Gestão",
  path: "/painel-dp/painel-gestao",
};

export const ROUTES = {
  AUTHENTICATION,
  PEOPLE_MANAGEMENT,
  PEOPLE_MANAGEMENT_PUNCH_CARD,
  PEOPLE_MANAGEMENT_GEOLOCATION_CARD,
  PERSONNEL_DEPARTMENT_PANEL,
  PERSONNEL_DEPARTMENT_OVERVIEW,
  PERSONNEL_DEPARTMENT_SENDING_NOTICES,
  PERSONNEL_DEPARTMENT_PUNCH_CARD_OBSERVATIONS,
  PERSONNEL_DEPARTMENT_MANAGEMENT_PANEL,
};

export const ROUTES_LIST: RouteItem[] = [
  AUTHENTICATION,
  PEOPLE_MANAGEMENT,
  PEOPLE_MANAGEMENT_PUNCH_CARD,
  PEOPLE_MANAGEMENT_GEOLOCATION_CARD,
  PERSONNEL_DEPARTMENT_PANEL,
  PERSONNEL_DEPARTMENT_OVERVIEW,
  PERSONNEL_DEPARTMENT_SENDING_NOTICES,
  PERSONNEL_DEPARTMENT_PUNCH_CARD_OBSERVATIONS,
  PERSONNEL_DEPARTMENT_MANAGEMENT_PANEL,
];

export function getRouteDescriptionByPath(path: string): string {
  return ROUTES_LIST.find(item => item.path === path)?.title ?? "";
}
